<div
  (click)="onCardClick()"
  class="bg-white border-2 border-border-subtle rounded-xl p-6 hover:border-signal-orange hover:-translate-y-1 hover:shadow-lg transition-all cursor-pointer"
>
  <!-- Header with title and status -->
  <div class="flex justify-between items-start mb-4">
    <h3 class="text-xl font-bold">{{ board().name }}</h3>
    <span
      class="text-white px-2 py-1 rounded text-xs font-semibold"
      [class]="statusClasses()"
    >
      {{ statusLabel() }}
    </span>
  </div>

  <!-- Board metadata -->
  <div class="flex gap-4 text-sm text-rail-gray mb-4">
    <span>📐 {{ boardDimensions() }}</span>
    <span>💬 {{ messageCount() }} messages</span>
    <span>👁 {{ viewCount() }} views</span>
  </div>

  <!-- Description -->
  @if (board().title) {
    <p class="text-sm text-rail-gray mb-6">
      {{ board().title }}
    </p>
  } @else {
    <p class="text-sm text-rail-gray mb-6 italic">No description</p>
  }

  <!-- Action buttons -->
  <div class="flex gap-2">
    <button
      (click)="onCopyUrl(); $event.stopPropagation()"
      [class]="urlCopied() ? 'w-9 h-9 bg-green-500 text-white rounded flex items-center justify-center transition-all cursor-pointer' : 'w-9 h-9 bg-bg-secondary hover:bg-signal-orange hover:text-white rounded flex items-center justify-center transition-all cursor-pointer'"
      [title]="urlCopied() ? 'Copied!' : 'Copy URL'"
      type="button"
    >
      {{ urlCopied() ? '✓' : '🔗' }}
    </button>
    <button
      (click)="onEdit(); $event.stopPropagation()"
      class="w-9 h-9 bg-bg-secondary hover:bg-signal-orange hover:text-white rounded flex items-center justify-center transition-all cursor-pointer"
      title="Edit"
      type="button"
    >
      ✏️
    </button>
    <button
      (click)="onPreview(); $event.stopPropagation()"
      class="w-9 h-9 bg-bg-secondary hover:bg-signal-orange hover:text-white rounded flex items-center justify-center transition-all cursor-pointer"
      title="Preview"
      type="button"
    >
      👁
    </button>
    <button
      (click)="onOpenInNewWindow(); $event.stopPropagation()"
      class="w-9 h-9 bg-bg-secondary hover:bg-signal-orange hover:text-white rounded flex items-center justify-center transition-all cursor-pointer"
      title="Open in new window"
      aria-label="Open in new window"
      type="button"
    >
      <svg
        aria-hidden="true"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M14 3h7v7" />
        <path d="M10 14 21 3" />
        <path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" />
      </svg>
    </button>
    <button
      (click)="onDelete(); $event.stopPropagation()"
      class="w-9 h-9 bg-bg-secondary hover:bg-signal-orange hover:text-white rounded flex items-center justify-center transition-all cursor-pointer"
      title="Delete"
      type="button"
    >
      🗑
    </button>
  </div>
</div>
